import api from './Api';
import { ImportRow, Mapping } from '../utils/productImport';
export interface ImportItem { row: number; name: string; barcode: string; productId: number | null; action: string; quantity: number; error: string | null }
export interface ImportPreview { id: string | null; items: ImportItem[]; errors: number; expiresAt: string | null }
export interface ImportReceipt { id: string; created: number; matched: number; unitsAdded: number }
export const ProductImportApi = {
  preview: (request: { companyId: number; depositId?: number; mode: string; rows: ImportRow[] }) => api.post<ImportPreview>('/ai/imports/preview', request, { suppressGlobalError: true }),
  confirm: (id: string) => api.post<ImportReceipt>(`/ai/imports/${id}/confirm`, {}, { suppressGlobalError: true, timeout: 120000 }),
  suggest: (headers: string[]) => api.post<Mapping>('/ai/imports/mapping', { headers }, { suppressGlobalError: true, timeout: 120000 }),
};
